var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _vm.changeNameShow
    ? _c("div", { staticClass: "popup" }, [
        _c("div", { staticClass: "content", attrs: { id: "changeName" } }, [
          _c(
            "div",
            {
              staticClass: "title",
              staticStyle: { "border-radius": "9px 9px 0 0" }
            },
            [
              _vm._v(
                "\r\n            " +
                  _vm._s(_vm.$t("language.popup.personalCenter.changeName")) +
                  "\r\n            "
              ),
              _c("div", {
                staticClass: "icon white-close dialog-close",
                on: {
                  click: function($event) {
                    _vm.changeNameShow = false
                  }
                }
              })
            ]
          ),
          _vm._v(" "),
          _c("div", { staticClass: "personInfo-content" }, [
            _c("div", { staticClass: "personInfo-column" }, [
              _c("span", [
                _vm._v(" " + _vm._s(_vm.$t("language.common.emailAccount")))
              ]),
              _vm._v(" "),
              _c("span", [
                _vm._v(_vm._s(_vm.$t("language.popup.addCloudPopup.userName")))
              ])
            ]),
            _vm._v(" "),
            _c(
              "div",
              { staticClass: "personInfo-column personInfo-column-msg" },
              [
                _c("p", { attrs: { title: _vm.email } }, [
                  _vm._v(_vm._s(_vm.email))
                ]),
                _vm._v(" "),
                _c("input", {
                  directives: [
                    {
                      name: "model",
                      rawName: "v-model",
                      value: _vm.userName,
                      expression: "userName"
                    }
                  ],
                  attrs: { type: "text" },
                  domProps: { value: _vm.userName },
                  on: {
                    blur: function($event) {
                      return _vm.verificationName()
                    },
                    input: function($event) {
                      if ($event.target.composing) {
                        return
                      }
                      _vm.userName = $event.target.value
                    }
                  }
                })
              ]
            ),
            _vm._v(" "),
            _c(
              "button",
              {
                staticClass: "personInfo-button",
                class: _vm.userName ? "" : "button-noclick",
                on: {
                  click: function($event) {
                    $event.stopPropagation()
                    return _vm.changeName()
                  }
                }
              },
              [_vm._v(_vm._s(_vm.$t("language.common.save")))]
            )
          ])
        ])
      ])
    : _vm._e()
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-3ae3375d", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-3ae3375d","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/popup/personal_center_popups/change_name_popup.vue
// module id = null
// module chunks = 